// extracted by mini-css-extract-plugin
export default {"container":"ButtonComp_container__XdXcy","fadeIn":"ButtonComp_fadeIn__IvNVM"};